import { useDispatch, useSelector } from 'react-redux';

import {
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverline,
} from '@frontend/components';

import { pluralize } from 'utils/stringUtils';

import { BulkEditQuantitiesDrawerForm } from './BulkEditQuantitiesDrawerForm';
import * as actions from './data/actions';
import { getIsOpen, getQuoteItemIds } from './data/reducer';

export const BulkEditQuantitiesDrawer = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(getIsOpen);
  const quoteItemIds = useSelector(getQuoteItemIds);

  const onClose = () => dispatch(actions.close());

  return (
    <Drawer isOpen={isOpen} onClose={onClose}>
      <DrawerContent>
        <DrawerHeader>
          <DrawerOverline>
            {pluralize('Line Item', quoteItemIds.length)}
          </DrawerOverline>
          Update Quantities
          <DrawerCloseButton />
        </DrawerHeader>
        <BulkEditQuantitiesDrawerForm />
      </DrawerContent>
    </Drawer>
  );
};
